<span>&copy; {{settings.getAppSetting('year')}} - {{ settings.getAppSetting('name') }} ({{ settings.getAppSetting('version') }} - {{ settings.getAppSetting('buildDate') }})</span>
